module.exports = __webpack_public_path__ + "media/icons/icon-select-8c49d624.png";